/* MRL home hero (home page only; loaded from snippets/mrl-missive-chat.liquid).
   1) HOLD SLIDE 1 WHILE THE PAGE LOADS (Cowork 9-29-26). The slider used to rotate while the page was
      still loading, so the lazy slide 2 banner became the page's "main image" late (desktop LCP 4.8s,
      phone Speed Index 15.4s). Now slide 1 stays put until the shopper interacts or the page has
      finished loading plus a short beat, then the slider rotates exactly as before. Uses the slider's
      own pause-on-hover (mouseenter pauses, mouseleave resumes), so no slider code changed. Taps,
      swipes, arrows and dots still work instantly.
   2) SHARPER BANNERS ON BIG / HIGH-DENSITY SCREENS (Fable 9-17-26). Adds 2400 / 2880 / 3840px options
      (never larger than the uploaded original). Now runs only after the page has loaded, so the
      bigger file never competes with the first paint. Small screens are unaffected. */
(function(){
  var BEAT_AFTER_LOAD = 3500; /* ms after the load event before rotation is allowed to start */
  var released = false;

  function roots(){
    var out = [];
    document.querySelectorAll('[data-cbs-viewport]').forEach(function(v){
      var r = v.closest('[id^="cbs-"]');
      if (r && out.indexOf(r) < 0) out.push(r);
    });
    return out;
  }
  function hold(){
    if (released) return;
    roots().forEach(function(r){ r.dispatchEvent(new Event('mouseenter')); });
  }
  function release(){
    if (released) return;
    released = true;
    roots().forEach(function(r){
      if (!r.matches(':hover')) r.dispatchEvent(new Event('mouseleave'));
    });
    ['pointerdown','keydown','wheel','touchstart'].forEach(function(t){ window.removeEventListener(t, release, true); });
  }

  function upgrade(){
    document.querySelectorAll('.cbs__img').forEach(function(img){
      var ss = img.getAttribute('srcset');
      if (!ss || / 2880w/.test(ss) || / 2400w/.test(ss)) return;
      var m = ss.match(/(\S+?[?&]width=)2000(\S*)\s+2000w/);
      if (!m) return;
      var nat = parseInt(img.getAttribute('width'), 10) || 0;
      var add = [];
      [2400, 2880, 3840].forEach(function(w){ if (nat >= w) add.push(m[1] + w + m[2] + ' ' + w + 'w'); });
      if (nat > 2000 && add.indexOf(m[1] + nat + m[2] + ' ' + nat + 'w') < 0 && [2400,2880,3840].indexOf(nat) < 0) add.push(m[1] + nat + m[2] + ' ' + nat + 'w');
      if (add.length) img.setAttribute('srcset', ss.replace(/\s+$/, '') + ', ' + add.join(', '));
    });
  }

  function afterLoad(){
    setTimeout(release, BEAT_AFTER_LOAD);
    if ('requestIdleCallback' in window) requestIdleCallback(upgrade, { timeout: 2000 }); else setTimeout(upgrade, 200);
  }

  /* The slider boots on DOMContentLoaded; this runs right after it and pauses rotation. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hold); else hold();
  /* Returning to the tab restarts the slider; keep holding until release. */
  document.addEventListener('visibilitychange', function(){ if (!document.hidden && !released) setTimeout(hold, 0); });
  /* Any real interaction ends the hold immediately. */
  ['pointerdown','keydown','wheel','touchstart'].forEach(function(t){ window.addEventListener(t, release, { capture: true, passive: true }); });
  if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad);
})();
